import axios from './index'

/**
 * heard 数据.
 */
export function selectHeards () {
  return axios.get('/web/items/popoverItems')
}
/**
 * 访问量记录.
 */
export function logVisit () {
  return axios.get('/web/visitLog/logVisit')
}
/**
 * 查询横幅图片集合.
 */
export function findBanner (linksId) {
  return axios.get('/web/banner/listByLinksId/' + linksId)
}
/**
 * 查询模块名称集合.
 */
export function findEnName (linksId) {
  return axios.get('/web/enName/listByLinksId/' + linksId)
}
/**
 * 查询模块名称.
 */
export function findEnNameOne (id) {
  return axios.get('/web/enName/findById/' + id)
}
/**
 * 查询产品与服务模块一信息.
 */
export function findProductsServicesOne (cnEnNameId) {
  return axios.get('/web/servicesOne/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询产品与服务模块二信息.
 */
export function findProductsServicesTwo (cnEnNameId) {
  return axios.get('/web/servicesTwo/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询产品与服务模块三信息.
 */
export function findProductsServicesThree (cnEnNameId) {
  return axios.get('/web/servicesThree/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询产品与服务模块四信息.
 */
export function findProductsServicesFour (cnEnNameId) {
  return axios.get('/web/servicesFour/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 新增需求.
 */
export function addDemand (params) {
  return axios.post('/web/contactUs', params)
}
/**
 * 查询解决方案模块一信息.
 */
export function findSolutionOne (cnEnNameId) {
  return axios.get('/web/solutionOne/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询解决方案模块二信息.
 */
export function findSolutionTwo (cnEnNameId) {
  return axios.get('/web/solutionTwo/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询解决方案模块三信息.
 */
export function findSolutionThree (cnEnNameId) {
  return axios.get('/web/solutionThree/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询解决方案模块四信息.
 */
export function findSolutionFour (cnEnNameId) {
  return axios.get('/web/solutionFour/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询解决方案模块五信息.
 */
export function findSolutionFive (cnEnNameId) {
  return axios.get('/web/solutionFive/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询生态价值模块一信息.
 */
export function findEcologicalOne (cnEnNameId) {
  return axios.get('/web/ecologicalOne/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询生态价值模块二信息.
 */
export function findEcologicalTwo (cnEnNameId) {
  return axios.get('/web/ecologicalTwo/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询生态价值模块三信息.
 */
export function findEcologicalThree (cnEnNameId) {
  return axios.get('/web/ecologicalThree/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询应用市场模块一信息.
 */
export function findApplicationMarketOne (cnEnNameId) {
  return axios.get('/web/productIntroduction/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询应用市场模块二信息.
 */
export function findApplicationMarketTwo (cnEnNameId) {
  return axios.get('/web/solutionAdvantages/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询应用市场模块三信息.
 */
export function findApplicationMarketThree (cnEnNameId) {
  return axios.get('/web/applicationScenarios/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询应用市场模块四信息.
 */
export function findApplicationMarketFour (cnEnNameId) {
  return axios.get('/web/cases/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询绑定新闻列表.
 */
export function getHomeList (cnEnNameId) {
  return axios.get('/web/news/getHomeList/' + cnEnNameId)
}
/**
 * 查询新闻列表.
 */
export function listNews (query) {
  return axios.get('/web/news/list2', {
    params: query
  })
}
/**
 * 查询新闻详情.
 */
export function findOneNews (newsId) {
  return axios.get('/web/news/findOne/' + newsId)
}
/**
 * 查询绑定资讯列表.
 */
export function getInformationHomeList (cnEnNameId) {
  return axios.get('/web/information/getInformationHomeList/' + cnEnNameId)
}
/**
 * 查询资讯列表.
 */
export function getInformationlList (query) {
  return axios.get('/web/information/getInformationlList2', {
    params: query
  })
}
/**
 * 查询资讯详情.
 */
export function findInformationOne (newsId) {
  return axios.get('/web/information/findInformationOne/' + newsId)
}
/**
 * 查询绑定首页视频.
 */
export function getVideoHome (cnEnNameId) {
  return axios.get('/web/videoNews/getVideoHomeList/' + cnEnNameId)
}
/**
 * 查询视频列表.
 */
export function getVideoList (query) {
  return axios.get('/web/videoNews/videsList2', {
    params: query
  })
}
/**
 * 查询视频详情.
 */
export function findVideoOne (newsId) {
  return axios.get('/web/videoNews/findVideoOne/' + newsId)
}

/**
 * 查询公司概况模块一信息.
 */
export function findWalkintoOne (cnEnNameId) {
  return axios.get('/web/companyProfile/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询公司概况模块二信息.
 */
export function findWalkintoTwo (cnEnNameId) {
  return axios.get('/web/corporateVideos/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询公司概况模块三信息.
 */
export function findWalkintoThree (cnEnNameId) {
  return axios.get('/web/cooperativePartner/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询资质荣誉模块一信息.
 */
export function findHonorOne (cnEnNameId) {
  return axios.get('/web/honorQualification/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询资质荣誉模块二信息.
 */
export function findHonorTwo (cnEnNameId) {
  return axios.get('/web/certificateHonor/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询资质荣誉模块三信息.
 */
export function findHonorThree (cnEnNameId) {
  return axios.get('/web/intellectualProperty/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询核心价值模块一信息.
 */
export function findCoreValueOne (cnEnNameId) {
  return axios.get('/web/coreValuese/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询核心价值模块二信息.
 */
export function findCoreValueTwo (cnEnNameId) {
  return axios.get('/web/guidelines/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询成功案例模块一信息.
 */
export function findProjectOne (cnEnNameId) {
  return axios.get('/web/successfulProjects/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询资环信息.
 */
export function findZhInfo () {
  return axios.get('/web/zhInfo/findZhInfo')
}

/**
 * 查询首页模块一.
 */
export function findHomeOne () {
  return axios.get('/web/homeOne/findByCnEnNameId')
}
/**
 * 查询首页模块二.
 */
export function findHomeTwo () {
  return axios.get('/web/homeTwo/findByCnEnNameId')
}
/**
 * 查询首页模块三.
 */
export function findHomeThree () {
  return axios.get('/web/homeThree/findByCnEnNameId')
}
/**
 * 查询首页模块四.
 */
export function findHomeFour () {
  return axios.get('/web/homeFour/findByCnEnNameId')
}
/**
 * 查询首页模块五.
 */
export function findHomeFive () {
  return axios.get('/web/homeFive/findByCnEnNameId')
}
/**
 * 查询核心技术模块一.
 */
export function findCoreTechnologyOne (cnEnNameId) {
  return axios.get('/web/coreTechnologyOne/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询核心技术模块二.
 */
export function findCoreTechnologyTwo (cnEnNameId) {
  return axios.get('/web/coreTechnologyTwo/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询核心技术模块三.
 */
export function findcoreTechnologyThree (cnEnNameId) {
  return axios.get('/web/coreTechnologyThree/findByCnEnNameId/' + cnEnNameId)
}
/**
 * 查询核心技术模块四.
 */
export function findCoreTechnologyFour (cnEnNameId) {
  return axios.get('/web/coreTechnologyFour/findByCnEnNameId/' + cnEnNameId)
}

/**
 * 查询成果案例详情.
 */
export function findOneProject (newsId) {
  return axios.get('/web/successfulProjects/findSuccessfulProjectsOne/' + newsId)
}
/**
 * 查询成果案例详情.
 */
export function findOneLink (linkId) {
  return axios.get('/web/links/findOne/' + linkId)
}
